jQuery(document).ready(function ($) {
  let modiSlider = $('.modi-slider')
  if (modiSlider.length) {
    modiSlider.slick({
      dots: true,
      rtl: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
    })
  }

  let textColumnsSlider = $('.text-columns__slider')
  if (textColumnsSlider.length) {
    textColumnsSlider.slick({
      dots: false,
      rtl: true,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })
  }

  if (jQuery('.mb-tabs').length) {
    $('.mb-tabs .tab_item').not(':first').hide()
    $('.mb-tabs__wrapper .tab')
      .click(function () {
        $('.mb-tabs__wrapper .tab')
          .removeClass('active')
          .eq($(this).index())
          .addClass('active')
        $('.mb-tabs .tab_item').hide().eq($(this).index()).fadeIn()
      })
      .eq(0)
      .addClass('active')
  }

  deleteDisabledAttr()

  //custom set product color after size change
  jQuery(document).on(
    'click',
    '.variant__input--color-swatch',
    function () {
      let th = jQuery(this)
      localStorage.setItem(
        'variantColor',
        th.parent().attr('data-value')
      )
    }
  )
  jQuery(document).on(
    'click',
    '.variant-input-wrap[data-index="option1"] input',
    function () {
      deleteDisabledAttr()
      let oldColorItem = localStorage.getItem('variantColor')
      if (oldColorItem !== undefined) {
        setTimeout(function () {
          jQuery(
            '.variant-input-wrap div[data-value="' +
              oldColorItem +
              '"] input'
          ).trigger('click')
        }, 500)
      }
    }
  )

  jQuery(document).on(
    'click',
    '.grid-product__link .quick-product__btn--not-ready',
    function (e) {
      if ($(window).width() <= 1024) {
        e.preventDefault()
      }
    }
  )

  jQuery(document).on(
    'click',
    '.page-width.page-width--flush-small .grid-product__colors .color-swatch--with-image',
    function (e) {
      if ($(window).width() <= 768) {
        e.preventDefault()
        var th = jQuery(this)
        var id = th.data('variant-id')
        var image = th.data('variant-image')
        var el = th
          .closest('.grid-product__content')
          .find('.grid-product__color-image--' + id)
        el.css('background-image', 'url( + image + )')
        el.addClass('is-active')
      }
    }
  )
})

function deleteDisabledAttr() {
  setTimeout(function () {
    let colors = document.querySelectorAll(
      '.variant-input-wrap div[data-index="option2"] input'
    )
    for (var i = 0; i < colors.length; i++) {
      colors[i].disabled = false
    }
  }, 400)
}
